module.exports = __webpack_public_path__ + "img/lunbo02_03.4ff767a5.png";